module.exports = __webpack_public_path__ + "images/148_1024.jpg";